// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"Button_buttonContainer__fHR_s","redirectButton":"Button_redirectButton__gs5P_"};